var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('a',{attrs:{"href":"https://docs.google.com/spreadsheets/d/1oJYDGS3bLt_yilMGUQV3MTdco1EZbguk4AmlQNZYbZQ/edit#gid=0","target":"_blank"}},[_vm._v(" pop ")])])}
var staticRenderFns = []

export { render, staticRenderFns }